/* @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import type { CmlContent } from 'bundles/cml/legacy/types/Content';
import { getInnerText, isCML } from 'bundles/cml/legacy/utils/CMLUtils';
import Tex from 'bundles/phoenix/components/Tex';

const styles = {
  text: css`
    font-size: 1.1em;
  `,
};

type Props = {
  cml: CmlContent;
};

const TWO_PARAGRAPH_CHAR_COUNT = 165;

const getTextSnippet = (cml: CmlContent) => {
  const text = getInnerText(cml);
  const trimmed = text.replace(/\n$/, ''); // trim trailing carriage return
  return trimmed.substr(0, TWO_PARAGRAPH_CHAR_COUNT);
};

export const CMLTextSnippet: React.FC<Props> = ({ cml }) => {
  if (!isCML(cml)) {
    return null;
  }

  const text = getTextSnippet(cml);

  return (
    <Typography2 component="div" css={styles.text}>
      <Tex>{text}</Tex>
    </Typography2>
  );
};
